import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import EnterpriseIcon, { PlusCircleIcon } from '@enterprise-ui/icons';
import classnames from 'classnames';
import React__default, { useState, useCallback, useEffect } from 'react';
import ReactDom from 'react-dom';
import useCanvasId from '../../utils/useCanvasId.js';

var InputDropWindow = function InputDropWindow(_ref) {
  var className = _ref.className,
    id = _ref.id,
    dataTestId = _ref['data-testid'],
    dropText = _ref.dropText,
    disabled = _ref.disabled,
    locationId = _ref.locationId,
    multiple = _ref.multiple,
    required = _ref.required,
    onUpdate = _ref.onUpdate;
  useCanvasId(id, 'DropWindow');
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    dragEnter = _useState2[0],
    setDragEnter = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    dragEnterCount = _useState4[0],
    setDragEnterCount = _useState4[1];
  var _useState5 = useState(document.getElementById(locationId)),
    _useState6 = _slicedToArray(_useState5, 2),
    locationForDropWindow = _useState6[0];
    _useState6[1];
  var callUpdate = useCallback(function (nextValue) {
    typeof onUpdate === 'function' && onUpdate(nextValue);
  }, [onUpdate]);
  var handleDrop = useCallback(function (e) {
    e.preventDefault();
    setDragEnterCount(0);
    setDragEnter(false);
    callUpdate(e);
  }, [callUpdate]);
  var handleDragOver = useCallback(function (e) {
    e.preventDefault();
    setDragEnter(true);
  }, []);
  var handleDragEnter = useCallback(function () {
    setDragEnterCount(dragEnterCount + 1);
  }, [dragEnterCount]);
  var handleDragLeave = useCallback(function () {
    setDragEnterCount(dragEnterCount - 1);
    if (dragEnterCount < 1) {
      setDragEnter(false);
    }
  }, [dragEnterCount]);
  useEffect(function () {
    if (!disabled) {
      window.addEventListener('dragenter', handleDragEnter, false);
      window.addEventListener('dragleave', handleDragLeave, false);
      window.addEventListener('dragover', handleDragOver, false);
      window.addEventListener('drop', handleDrop, false);
    }
    return function () {
      if (!disabled) {
        window.removeEventListener('dragenter', handleDragEnter, false);
        window.removeEventListener('dragleave', handleDragLeave, false);
        window.removeEventListener('dragover', handleDragOver, false);
        window.removeEventListener('drop', handleDrop, false);
      }
    };
  }, [disabled, handleDragEnter, handleDragLeave, handleDragOver, handleDrop]);
  var parentClasses = classnames('C-DropWindow', {
    isDisabled: disabled,
    isHover: dragEnter
  }, className);
  var buttonClasses = classnames('C-DropWindow__Button', {
    isDisabled: disabled
  }, className);
  var renderDropWindow = function renderDropWindow() {
    return /*#__PURE__*/React__default.createElement("label", {
      htmlFor: id,
      "aria-label": "Click to upload a file. ".concat(required ? 'Required field.' : ' ')
    }, /*#__PURE__*/React__default.createElement("input", {
      "data-testid": dataTestId,
      onChange: callUpdate,
      disabled: disabled,
      type: "file",
      id: id,
      multiple: multiple,
      required: required,
      className: "C-DropWindow__Input",
      "aria-hidden": "true",
      tabIndex: "-1"
    }), /*#__PURE__*/React__default.createElement("div", {
      className: parentClasses
    }, /*#__PURE__*/React__default.createElement("button", {
      disabled: disabled,
      className: buttonClasses
    }, /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
      icon: PlusCircleIcon
    }), dropText ? dropText : 'Drop files to upload')));
  };
  if (locationId) {
    return /*#__PURE__*/ReactDom.createPortal(renderDropWindow(), locationForDropWindow);
  } else {
    return renderDropWindow();
  }
};
InputDropWindow.displayName = 'Input.DropWindow';

export { InputDropWindow as default };
